import React, { useState } from "react";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed w-full z-50 bg-black/70 backdrop-blur-md text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo / Brand */}
          <div className="flex-shrink-0">
            <img
              src="/images/logo/logo.png"
              alt="Perfect Auto Body Logo"
              className="h-16 sm:h-20 w-auto"
            />
          </div>

          {/* Desktop Links */}
          <div className="hidden md:flex space-x-10 text-lg">
            <a href="#home" className="hover:text-slate-400 transition">
              Home
            </a>
            <a href="#services" className="hover:text-slate-400 transition">
              Services
            </a>
               <a href="#gallery" className="hover:text-slate-400 transition">
              Gallery
            </a>
            <a href="#about" className="hover:text-slate-400 transition">
              About
            </a>
            <a href="#contact" className="hover:text-slate-400 transition">
              Contact
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              className="text-slate-300 hover:text-slate-100 focus:outline-none focus:ring-2 focus:ring-slate-100"
            >
              {isOpen ? (
                <svg
                  className="h-8 w-8"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  className="h-8 w-8"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-black/90 backdrop-blur-sm px-2 pt-4 pb-3 space-y-2 text-lg">
          <a
            href="#home"
            className="block px-4 py-3 rounded-md font-medium text-slate-100 hover:bg-slate-700 hover:text-slate-300 transition"
          >
            Home
          </a>
          <a
            href="#services"
            className="block px-4 py-3 rounded-md font-medium text-slate-100 hover:bg-slate-700 hover:text-slate-300 transition"
          >
            Services
          </a>

             <a
            href="#gallery"
            className="block px-4 py-3 rounded-md font-medium text-slate-100 hover:bg-slate-700 hover:text-slate-300 transition"
          >
            Gallery
          </a>
          <a
            href="#about"
            className="block px-4 py-3 rounded-md font-medium text-slate-100 hover:bg-slate-700 hover:text-slate-300 transition"
          >
            About
          </a>
          <a
            href="#contact"
            className="block px-4 py-3 rounded-md font-medium text-slate-100 hover:bg-slate-700 hover:text-slate-300 transition"
          >
            Contact
          </a>
        </div>
      )}
    </nav>
  );
}
